import { useEffect, useState } from 'react';

import { useGlobalDialog } from "../../../Store/DialogManager";

import { useSnackbar } from "notistack";
import styled from 'styled-components';

import { useModuleSettingsHook } from '../../../Hooks/Maintenance/ModulesSettings/modulesSettingsHooks';

import { ModuleSetting, AddEditModuleModalInterface } from '../../../Models/Maintenance/ModuleSetting/Module';

import RequiredParametersHelper from '../../../Utilities/Helpers/RequiredParametersHelper';
import RequiredFieldHelper from '../../../Utilities/Helpers/RequiredFieldHelper';
import QueryBuilderHelper from '../../../Utilities/Helpers/QueryBuilderHelper';

import { ButtonType } from '../../../Utilities/Enums/ButtonTypeEnum';
import { ModuleSettingField } from '../../../Utilities/Enums/ParametersEnum';
import { CachingEnum } from '../../../Utilities/Enums/CachingEnum';

import CustomButton from '../../../CustomViews/Elements/CustomButton';
import FormTextField from '../../../CustomViews/Elements/FormTextField';
// import AutoCompleteDropdown from '../../../CustomViews/Elements/AutoCompleteDropdown';

const ModalContentContainer = styled.div <{ $darkMode?: boolean; }>`
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
    width: 30vw;
`;

export default function AddEditModuleModal(props: AddEditModuleModalInterface) {
    let { openAddEditModal, setopenAddEditModal, selectedModule, setselectedModule } = props;
    const { enqueueSnackbar } = useSnackbar();
    const { setDialogContent, setOpenGlobalDialog } = useGlobalDialog();
    let requiredFields = RequiredParametersHelper.moduleSettings();

    //Use States
    let [errorMessages, setErrorMessages]: any = useState({});
    const [queryStr, setQueryStr] = useState({
        pageSize: QueryBuilderHelper.DefaultPageSizeValue(),
        pageNumber: QueryBuilderHelper.DefaultPageNumValue(),
        searchString: QueryBuilderHelper.DefaultSearchValue(),
    });

    const q_queryKey = [CachingEnum.MODULE_SETTING, queryStr]
    const { DropdownData, dropdownFetchStatus, createModuleSettings, editModuleSettingsById } = useModuleSettingsHook(q_queryKey, queryStr, false);


    const nameProps = {
        name: ModuleSettingField.NAME,
        title: 'Name',
        fieldValue: selectedModule?.[ModuleSettingField.NAME] ?? "",
        type: 'text',
        required: requiredFields?.find((field: any) => field.keyName == ModuleSettingField.NAME)?.keyName != null,
        errorMessages: errorMessages,
        handleOnChange: (selectedValue: any) => {
            if(setselectedModule) {
                setselectedModule(prev => ({ ...prev, [ModuleSettingField.NAME]: selectedValue }));
            }
        },
    },
        descriptionProps = {
            name: ModuleSettingField.DESCRIPTION,
            title: 'Description',
            fieldValue: selectedModule?.[ModuleSettingField.DESCRIPTION] ?? "",
            type: 'text',
            required: requiredFields?.find((field: any) => field.keyName == ModuleSettingField.DESCRIPTION)?.keyName != null,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                if(setselectedModule) {
                    setselectedModule(prev => ({ ...prev, [ModuleSettingField.DESCRIPTION]: selectedValue }));
                }
            },
        };
        // statusProps = {
        //     name: ModuleSettingField.STATUS,
        //     title: 'Status',
        //     fieldValue: selectedModule?.[ModuleSettingField.STATUS] ?? "",
        //     options: DropdownData?.[CachingEnum.STATUS_LIST] ?? [],
        //     isLoadingDropdown: dropdownFetchStatus ?? false,
        //     required: requiredFields?.find((field: any) => field.keyName == ModuleSettingField.STATUS)?.keyName != null,
        //     errorMessages: errorMessages,
        //     handleOnChange: (selectedValue: any) => {
        //         if(setselectedModule) {
        //             setselectedModule((prev: any) => ({ ...prev, [ModuleSettingField.STATUS]: selectedValue?.id ?? '' }));
        //         }
        //     },
        // };

    //Event Handlers
    const onCloseDialog = async (e: any = null) => {
        if(e) {
            e.preventDefault();
        }

        if(setopenAddEditModal) {
            setopenAddEditModal(false);
        }

        if(setselectedModule) {
            setselectedModule(new ModuleSetting());
        }

        setOpenGlobalDialog(false);
    }

    useEffect(() => {
        if(openAddEditModal) {
            setDialogContent({
                title: (!selectedModule?.[ModuleSettingField.PUBLIC_ID] ? "Add" : "Edit") + " Module",
                clearDialog: onCloseDialog,
                onCloseDialog: onCloseDialog,
                actionButtons: renderActionButtons(),
                children: renderDialogContent(),
            });
        }
    }, [openAddEditModal, selectedModule, errorMessages]);

    const handleSubmit = async () => {
        let _validateForm = RequiredFieldHelper.validateForm(requiredFields, selectedModule, errorMessages, setErrorMessages, enqueueSnackbar);

        if (_validateForm?.hasError) { return true; }

        let _success: boolean = false;

        if(!selectedModule?.[ModuleSettingField.PUBLIC_ID]) {
            let createResponse = await createModuleSettings(JSON.stringify(selectedModule));
            
            _success = createResponse?.isSuccess ?? false;
        } else {
            let editResponse = await editModuleSettingsById(selectedModule?.[ModuleSettingField.PUBLIC_ID], JSON.stringify(selectedModule));
            
            _success = editResponse?.isSuccess ?? false;
        }

        if(_success) {
            onCloseDialog();
        }
    }

    //Rendering Functions
    const renderActionButtons = () => {
        return <>
            <CustomButton
                btnType={ButtonType.CANCEL}
                title='Close'
                onClick={(e: any) => {
                    onCloseDialog(e);
                }} />

            <CustomButton
                btnType={ButtonType.SUCCESS}
                title='Save'
                onClick={(e: any) => {
                    handleSubmit();
                }} />
        </>
    }

    const renderDialogContent = () => {
        return <ModalContentContainer>
            <FormTextField {...nameProps} />
            <FormTextField {...descriptionProps} />
            {/*<AutoCompleteDropdown {...statusProps} />*/}
        </ModalContentContainer>
    }

    return <></>
}